module.exports = __webpack_public_path__ + "img/media-zh.619a849f.jpg";